import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaWineGlass, FaShippingFast, FaAward, FaLeaf } from 'react-icons/fa';
import { productsAPI, commercialRequestsAPI } from '../utils/api';
import ProductCard from '../components/ProductCard';
import '../styles/HomePage.css';
import { toast } from 'react-toastify';

const HomePage = () => {
  const [featuredProducts, setFeaturedProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCommercialForm, setShowCommercialForm] = useState(false);
  const [commercialForm, setCommercialForm] = useState({
    azienda: '',
    nome: '',
    email: '',
    telefono: '',
    messaggio: ''
  });
  const [sendingCommercial, setSendingCommercial] = useState(false);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const data = await productsAPI.getAll({ limit: 6, sort: 'popolare' });
        setFeaturedProducts(data);
      } catch (error) {
        console.error('Errore caricamento prodotti:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchFeatured();
  }, []);

  const handleCommercialChange = (field, value) => {
    setCommercialForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleCommercialSubmit = async (e) => {
    e.preventDefault();
    try {
      setSendingCommercial(true);
      await commercialRequestsAPI.create(commercialForm);
      toast.success('Richiesta inviata! Ti ricontatteremo a breve.');
      setCommercialForm({
        azienda: '',
        nome: '',
        email: '',
        telefono: '',
        messaggio: ''
      });
      setShowCommercialForm(false);
    } catch (error) {
      toast.error(error.response?.data?.message || 'Errore invio richiesta');
    } finally {
      setSendingCommercial(false);
    }
  };

  const features = [
    { icon: <FaWineGlass />, title: 'Qualità Premium', desc: 'Selezione di cantine e produttori italiani' },
    { icon: <FaShippingFast />, title: 'Spedizione Veloce', desc: 'Consegna in 24-48h in tutta Italia' },
    { icon: <FaAward />, title: 'Vini Premiati', desc: 'Riconoscimenti nazionali e internazionali' },
    { icon: <FaLeaf />, title: 'Bio & Sostenibile', desc: 'Coltivazione biologica certificata' }
  ];

  return (
    <div className="homepage">
      <section className="hero">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="hero-content container"
        >
          <img className="hero-logo" src="/images/logowine.png" alt="Cà del Vin" />
          <h1 className="hero-title">
            L'Eccellenza del Vino <span className="gradient-text">Italiano</span>
          </h1>
          <p className="hero-subtitle">
            Scopri vini artigianali da produttori selezionati, con passione e tradizione
          </p>
          <Link to="/catalogo" className="btn btn-gold btn-hero">
            Esplora il Catalogo
          </Link>
        </motion.div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features-grid">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="feature-card"
              >
                <div className="feature-icon">{feature.icon}</div>
                <h3>{feature.title}</h3>
                <p>{feature.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="featured-products">
        <div className="container">
          <h2 className="section-title text-center">Vini in Evidenza</h2>
          {loading ? (
            <div className="flex-center" style={{ padding: '3rem' }}>
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="products-grid">
              {featuredProducts.map((product) => (
                <ProductCard key={product._id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>

      <section className="commercial-contact">
        <div className="container">
          <div className="commercial-card">
            <div>
              <h2>Se sei un'attivita commerciale contattaci direttamente qui</h2>
              <p>Richiedi listini dedicati, condizioni riservate e informazioni per il canale B2B.</p>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => setShowCommercialForm((prev) => !prev)}
            >
              {showCommercialForm ? 'Chiudi' : 'Apri il form'}
            </button>
          </div>

          {showCommercialForm && (
            <form className="commercial-form" onSubmit={handleCommercialSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Azienda *</label>
                  <input
                    type="text"
                    className="input"
                    value={commercialForm.azienda}
                    onChange={(e) => handleCommercialChange('azienda', e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Nome e Cognome *</label>
                  <input
                    type="text"
                    className="input"
                    value={commercialForm.nome}
                    onChange={(e) => handleCommercialChange('nome', e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email *</label>
                  <input
                    type="email"
                    className="input"
                    value={commercialForm.email}
                    onChange={(e) => handleCommercialChange('email', e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Telefono</label>
                  <input
                    type="text"
                    className="input"
                    value={commercialForm.telefono}
                    onChange={(e) => handleCommercialChange('telefono', e.target.value)}
                  />
                </div>
              </div>
              <div className="form-group">
                <label>Messaggio</label>
                <textarea
                  className="input"
                  rows="4"
                  value={commercialForm.messaggio}
                  onChange={(e) => handleCommercialChange('messaggio', e.target.value)}
                  placeholder="Raccontaci la tua attivita e le tue esigenze..."
                />
              </div>
              <button type="submit" className="btn btn-gold" disabled={sendingCommercial}>
                {sendingCommercial ? 'Invio...' : 'Invia richiesta'}
              </button>
            </form>
          )}
        </div>
      </section>
    </div>
  );
};

export default HomePage;
